import { render, staticRenderFns } from "./EventDocuments.vue?vue&type=template&id=77f8b2a5"
import script from "./EventDocuments.vue?vue&type=script&lang=js"
export * from "./EventDocuments.vue?vue&type=script&lang=js"
import style0 from "./EventDocuments.vue?vue&type=style&index=0&id=77f8b2a5&prod&lang=scss"
import style1 from "./EventDocuments.vue?vue&type=style&index=1&id=77f8b2a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports